import { mailPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  // Business Mail is tenant-implicit (one account per organization): no id in the URL.
  { scope: 'External.VMail', category: 'mail', route: () => mailPaths.base },
] as const;
